import React from 'react';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const MaranaTheetuPage = () => {
  return (
    <div style={{ padding: '15px', background: T.bg, minHeight: '100vh', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.2rem', fontWeight: 900 }}>அறிமுகம்</h1>
      </div>
      <div dangerouslySetInnerHTML={{ __html: `

<ion-content style="padding-left: 5px; padding-right: 5px;">
  <h1>மரணத் தீட்டுகள் </h1>
  
<div class="color4">
  <div class="div3">
  மரணத்தினால் ஏற்படும் தீட்டுகள் ஒருநாள், 
  ஒன்றரை நாள், மூன்று நாள், பத்து நாட்கள் 
  என நான்கு வகைப்படும். அவை தனித்தனியாக பிரித்து
  கீழே வகைப்படுத்தி வழங்கப்பட்டுள்ளன. 
  முதலில் பத்துநாளில் ஆரம்பித்து, பின் மூன்று நாள், 
  ஒன்றரை நாள், ஒரு நாள் என எந்தப் பகுதியில்
  தங்களுடைய உறவு முறை வழங்கப்பட்டுள்ளது 
  என தீர்மானித்துக்கொள்ளவும். 
  சில சமயம் இருவிதமான உறவு முறைகள் இருக்கலாம்.
   அப்படி இருக்கும்போது
  அதிகப்படியான தீட்டு எந்த உறவினால் ஏற்படுகிறதோ 
  அந்தத் தீட்டையே அநுஷ்டிக்கவேண்டும்.
  <span class="svk">ஒன்றரை நாள் (அ) 90 நாழி தீட்டில் 
    நேரும் பகல் காலங்களில் உணவு அருந்தாமல் இருந்து 
    அந்தி நேரத்தில் தீர்த்தமாடினால் 
    மட்டுமே 90 நாழியில் தீட்டு முடியும். 
  உணவருந்தினால் அடுத்த நாள் விடியற்காலையில் தீர்த்தமாடிய 
  பின்னரே முடியும்.
  </span>
</div>
</div>

      <div class="head2">
        தலைமுறை கணக்கீடு?
      </div>    
    
    <div class="color4">
      <div class="div3">
    தீட்டில் எவர் எந்தத் தலைமுறையைச் 
    சேர்ந்தவர் எனக் கணக்கிடுவதில் நிறைய குழப்பங்கள் உள்ளன.
    <hr> ஆயினும் பெரும்பாலும் அனைவராலும் 
    ஏற்றுக்கொள்ளக்கூடிய கணக்கீடு கீழ்வறுமாறு.
    <ol class="myol">
      <li>
        ஒருவன் (நாமி) தன்னை நான்காவது 
        தலைமுயைாக வைத்துக்கொள்ளவேண்டும் </li>
      <li>நாமியின் தந்தை (பிதா) 3ம் தலைமுறை</li>
      <li>நாமியின் தந்தைக்குத் தந்தை (பிதாமஹர்)
         2ம் தலைமுறை</li>
      <li>நாமியின் தந்தைக்குத் தந்தைக்குத் தந்தை 
        (ப்ரபிதாமஹர்) 1ம் தலைமுறை</li>
      <li>நாமியின் பிள்ளை (புத்ரன்) 5ம் தலைமுறை</li>
      <li>நாமியின் பிள்ளைவழிப் பேரன் (பௌத்ரன்)
         6ம் தலைமுறை </li>
      <li>நாமியின் பிள்ளையின் 
        பிள்ளைவழிப் பேரன் (ப்ரபௌத்ரன்) 7ம் தலைமுறை</li>
    </ol>
    குறிப்பு:- எல்லோருக்கும் 7 தலைமுறையும் 
    உறவு இருந்தே ஆகவேண்டும் என்று 
    எந்தக் கட்டாயமும் கிடையாது.
    <hr> இப்படிப்பட்ட 7 தலைமுறை 
    உறவில் இருந்தால் அவர்களுக்கு 10 நாள் தீட்டு 
    என்பதற்காகவே தரப்பட்டுள்ளது.
      </div></div>
   <div class="head2">பெண்களுக்கு மட்டும் தீட்டு
  </div>
  <div class="color4">
    <div class="div3">
  இனி மரணத்தினால் பெண்களுக்கு மட்டில்
   (கணவர் மற்றும் கணவர் குடும்பத்தாருக்குக் கிடையாது)
    ஏற்படும் தீட்டுகள் விபரம் கீழ்வறுமாறு
  --
  <hr> பெண்களுக்கு திருமணத்தின் மூலம் கோத்திரம்
   வேறு படுகிறது. கணவனின் கோத்திரத்தை (சந்ததியைச்) 
   சேர்ந்தவர்களின் பிறப்பு இறப்பே
  அவளுக்கும் உரியதாகும். ஆயினும் பிறந்தகத்தைச் 
  சேர்ந்த சிலரது மரணத்தினால் பெண்களுக்கு மட்டும் 
  3 நாள் வரை தீட்டு சம்பவிக்கும்
  இந்த தீட்டு அவர்களுடைய கணவருக்குக் கிடையாது. 
  தூரமான ஸ்த்ரீ தனித்திருந்து தீட்டுக் காப்பது போல 
  இதை அவள் மட்டும் காக்க வேண்டியது.
  

  பெண்களின் கீழ்க்கண்ட 
    உறவினரின் மரணத்தில் அவளுக்கு மட்டும் 3 நாள் தீட்டு:
    <ol class="myol">
      <li>உபநயனமான உடன்பிறந்த ஸஹோதரன்</li>
      <li>உபநயனமான மருமான் (ஸஹோரதன் பிள்ளை)</li>
      <li>உபநயனமான ஸஹோதரியின் பிள்ளை</li>
      <li>இளைய அல்லது மூத்த தாயார் (தந்தையின் வேறு மனைவிகள்)</li>
    </ol>

    பக்ஷிணீ என்பது இரண்டு பகலும் ஓர் இரவும் அல்லது இரண்டு இரவும் ஒரு பகலும் கொண்ட நேரம். பகலின் அல்லது இரவின் கடைசீ பகுதியில்
    அறியப்பட்டாலும் அந்த பொழுது தீட்டில் கழிந்துவிட்டதாகவே பொருள்.
    <hr>
    கீழ்கண்ட பட்டியலில் உள்ளவர்களின் மரணத்தினால் பெண்களுக்கு பக்ஷிணீ தீட்டு. (ஒன்றரை நாள்)

      <ol class="myol">
        <li>தந்தையுடன் பிறந்த பெரியப்பா, சித்தப்பா</li>
        <li>தாயுடன் பிறந்த சித்தி, பெரியம்மா</li>
        <li>தாயின் ஸஹோதரர்கள் (மாதுலன்)</li>
        <li>தந்தையின் ஸஹோதரிகள் (அத்தை)</li>
        <li>மேல் நான்கு வகையினரின் பெண்கள், பிள்ளைகள்</li>
        <li>தந்தையின் தந்தை - பிதாமஹன்</li>
        <li>தந்தையின் தாய் - பிதாமஹி</li>
        <li>தாயின் தந்தை - மாதாமஹன்</li>
        <li>தாயின் தாய் - மாதாமஹி</li>
        <li>உடன் பிறந்த ஸஹோதரி</li>
        <li>ஸஹோதரியின் பெண்கள்</li>
        <li>மருமாள் (ஸஹோதரனின் பெண்)</li>
        <li>பெரியப்பா, சித்தப்பா இவர்களது பெண்கள்</li>
        <li>மாமா, அத்தை இவர்களது பெண்கள்</li>
      
      </ol>

      கீழ்கண்டவர்கள் உபநயனமான ஆண், விவாஹமான பெண் மரணத்தால் பெண்களுக்கு மட்டும் 1 நாள் தீட்டு.

        <ol class="myol">
          <li>மாற்றாந் தாயின் சகோதரன்</li>
          <li>மாற்றாந் தாயின் சகோதரி</li>
          <li> மாற்றாந் தாயின் பிள்ளை</li>
          <li> மாற்றாந் தாயின் பெண் </li>
          <li> மாற்றாந் தாயின் பேரன்</li>
          <li> மாற்றாந் தாயின் பேத்தி</li>
          <li>தன் தந்தையின் மாற்றாந் தாயின் பிள்ளை</li>
          <li>தன் தந்தையின் மாற்றாந் தாயின் பெண்</li>
          <li>தன் தந்தையின் மாற்றாந் தாயின் பிள்ளையின் பெண் (அ) பிள்ளை</li>
          <li>தன் தந்தையின் மாற்றாந் தாயின் பெண்ணின் பெண் (அ) பிள்ளை</li>
          <li>தன் தந்தையின் மாற்றாந் தாயின் தந்தை</li>
          <li>தன் தந்தையின் மாற்றாந் தாயின் தாய்</li>
        </ol>
        மணமான பெண்ணின் கீழ்க்கண்ட உறவினர் மரணத்தில் வெறும் ஸ்நானம் மட்டும். 
        <ol class="myol">
          <li>தாயின் சகோதரர் மனைவி (மாமி)</li>
          <li>தந்தையின் சகோதரி கணவர் (அத்திம்பேர்)</li>
          <li>சகோதரி வகையினரின் கணவன்மார்</li>
        </ol>
    </div></div>
  <div class="head2">மரண தீட்டுகள் பட்டியல்
  </div>
  <div class="color4">
    <div class="div3">
        மரணத்தினால் ஏற்படும் தீட்டுகள், உறவின் நெருக்கத்தைப் பொறுத்து 10 நாள், 3நாள், ஒன்றரை நாள், ஒரு நாள் என நான்கு வகைப்படும்.
        <hr>இதில் கவனிக்கவேண்டிய விஷயம். குடும்பத் தலைவருக்கு தீட்டு ஏற்பட்டுவிட்டால் அந்த வீட்டில் உள்ள மற்றவர்கள் அவருக்குண்டான
        தீட்டை அநுசரித்தே நடக்கவேண்டும். தீட்டில் உள்ளவரின் பொருட்களுக்கும் தீட்டு உண்டு. ப்ரும்மச்சாரிக்குத் தீட்டுக் கிடையாதே, கன்யாபெண்ணுக்குத் தீட்டுக் கிடையாதே அவா விளக்கு
        ஏற்றலாமா? அவா பெருமாளுக்கு அமிசை பண்ணலாமா ? என்றெல்லாம் வேறுபடுத்தி யோசிக்கக்கூடாது.
        <hr> தீட்டில்லாதவர்கள் தீட்டுள்ளவர்களுடன் கலந்து இருந்தால் அவர்களும் தீட்டு ஸம்பந்தம் உள்ளவர்கள் ஆகிவிடுவர். மேலும் 
        தீட்டு நியமங்கள்  விபரமாக வழங்கப்பட்டுள்ளது. 
    </div></div>
        <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0">No</td>
            <td style="padding:8px; border:1px solid #e0e0e0">யாருக்கு</td>
            <td style="padding:8px; border:1px solid #e0e0e0"> இறப்பு விபரம் </td>
            <td style="padding:8px; border:1px solid #e0e0e0"> தீட்டு</td>        
          </tr>
          <tr style="border-bottom:1px solid #ccc">
            <td style="padding:8px; border:1px solid #e0e0e0"></td>
            <td style="padding:8px; border:1px solid #e0e0e0">  </td>
            <td style="padding:8px; border:1px solid #e0e0e0"> <br> </td>
            <td style="padding:8px; border:1px solid #e0e0e0"> </td>
            
          </tr>
        </table>    
       



` }} />
    </div>
  );
};

export default MaranaTheetuPage;
